import { AppContext } from "@components/features/appContext/AppContext";
import { config } from "@utils/config";
import { useContext } from "react";
import Button, { ButtonProps } from "../form/Button";

type Props = {
  buttonTheme?: ButtonProps["theme"];
};

const ThemeToggle = ({ buttonTheme }: Props) => {
  const { theme, setTheme } = useContext(AppContext);

  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    localStorage.setItem(config.localStorage.theme, newTheme);
    setTheme(newTheme);
  };

  return (
    <Button
      onClick={() => toggleTheme()}
      className="h-full"
      theme={buttonTheme}
    >
      {theme === "light" ? (
        <svg
          className="h-5 w-8 text-white"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
          />
        </svg>
      ) : (
        <svg
          className="h-5 w-8 text-white"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
          />
        </svg>
      )}
    </Button>
  );
};

export default ThemeToggle;
